export default "__VITE_ASSET__DvM5c0Me__"